/* eslint-disable space-before-function-paren */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { updateQueryStringParameter, deepCopyObject, setLocalStorage, getLocalStorage, loadScript } from 'mazey';
import { Spin } from 'antd';

class Tiny extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    // init
    loadScript({
      url: 'https://mazey.cn/static/js/tiny.js',
      timeout: 10000,
    })
      .then(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb pull-right">
          <li className="breadcrumb-item">首页</li>
          <li className="breadcrumb-item">小工具</li>
          <li className="breadcrumb-item active">短链接生成</li>
        </ol>
        <h1 className="page-header">短链接生成 <small></small></h1>

        <div className="row">
          <div className="col-lg-12">
            <Panel>
              <PanelHeader>
                短链接生成
              </PanelHeader>
              <PanelBody>
                <div className="row">
                  <div className="col-md-12">
                    <Spin spinning={this.state.loading}>
                      <div id="tiny-box" style={{
                        backgroundColor: '#eee',
                        minHeight: '150px',
                      }}>
                        <span>loading</span>
                      </div>
                    </Spin>
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default Tiny;
